import { SeoData } from '@api/seo/types';

import { isLocalOrDevEnvironment } from '@utils/config';

/**
 * CMS `is_indexing=false` → noindex meta.
 * On prod/layta (non-local/DEV) do not close indexing via this flag:
 * after the switch many SEO rows still have is_indexing=false, while robots.txt
 * already covers cart/lk/etc. Re-enable full CMS respect later when data is fixed.
 */
export const isCmsNoindex = (isIndexing?: SeoData['is_indexing']): boolean => {
    if (!isLocalOrDevEnvironment()) {
        return false;
    }

    if (isIndexing === undefined || isIndexing === null || isIndexing === '') {
        return false;
    }

    if (typeof isIndexing === 'boolean') {
        return !isIndexing;
    }

    if (typeof isIndexing === 'number') {
        return isIndexing === 0;
    }

    const value = String(isIndexing).trim().toLowerCase();

    return value === '0' || value === 'false' || value === 'no';
};
